export const productName = 'SURVEYING & TOPOGRAPHY TEACHER READY';
export const productShortName = 'Surveying & Topography Teacher Ready';
export const productTagline = 'Master your year of surveying & topography in one afternoon';
export const productImage = 'https://cdn.magicpatterns.com/uploads/9YHStWSKtVfEKzkPStjgYa/MOCKUP_4.58.20_p._m..png';

export const checkoutUrl = 'https://surveying-topography-teacher-ready.impultienda.ar/checkout';

export const price = 'USD 27.00';
export const priceBefore = 'USD 80.00';

export const totalVolumes = 9;
export const totalBonuses = 4;
export const bonusTotalValue = 'USD 56.00';

export const included = [
  'Volume 1 — Surveying & Topography Fundamentals',
  'Volume 2 — Distance, Angle & Elevation Measurements',
  'Volume 3 — Leveling & Elevation Surveying',
  'Volume 4 — Traversing, Coordinates & Survey Calculations',
  'Volume 5 — Surveying Instruments & Field Procedures',
  'Volume 6 — GNSS, GPS & Modern Surveying Technologies',
  'Volume 7 — Topographic Surveys, Contours & Terrain Representation',
  'Volume 8 — Applied Surveying: Construction, Roads & Land Projects',
  'Volume 9 — Teaching Surveying & Topography',
  'Bonus 1 — 150 Classroom Activities',
  'Bonus 2 — Assessment Bank',
  'Bonus 3 — 50 Projects & Challenges',
  "Bonus 4 — Teacher's Reference & Terminology Handbook",
  '7-day money-back guarantee',
  'Instant access',
];

export const systemNegatives = [
  "It's not outdated theory copied from old textbooks.",
  "It's not a collection of disconnected activities.",
  "It's not material you'll need to completely rewrite.",
];

export const closingLines = [
  'No more sleepless nights searching for ways to explain complex surveying procedures',
  "No more rushed lessons with materials that don't work",
  "No more disconnected students who don't see surveying's relevance",
  'No more weekends spent building lesson plans from scratch',
  "No more awkward silences when students ask technical questions you weren't ready for",
];
